import { Request } from '../../Servidor/Request';

export class ZoneRequest {
    private sgepzona: number;
    private nome: string;

    constructor(sgepzona: number, nome: string) {
        this.sgepzona = sgepzona;
        this.nome = nome;
    }


    /**
     * Getter sgepzona
     * @return {number}
     */
    public getSgepZona(): number {
        return this.sgepzona;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class ZoneStructRequest {
    private sgepzona: number;

    constructor(sgepzona: number) {
        this.sgepzona = sgepzona;
    }


    /**
     * Getter sgepzona
     * @return {number}
     */
    public getSgepZona(): number {
        return this.sgepzona;
    }

}

export class ZoneStructResponse {
    private sgepzona: number;
    private nome: string;

    constructor(sgepzona: number, nome: string) {
        this.sgepzona = sgepzona;
        this.nome = nome;
    }


    /**
     * Getter sgepzona
     * @return {number}
     */
    public getSgepZona(): number {
        return this.sgepzona;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class ZoneInteractor {
    public fetchSave(request: ZoneRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/zona/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: ZoneStructRequest): PromiseLike<ZoneStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/zona/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}